import styled from 'styled-components';
export const Header = styled.div `
  display: flex;
  align-items: center;
`;
export const ProgressBarContainer = styled.div `
  flex: 1;
  position: relative;
  margin-right: 5px;
`;
